import {
  TOrder,
  deliveryTypeText as defaultDeliveryTypeText,
  orderStatusText as defaultOrderStatusText,
} from "./Order.interface";
import { searchInProduct } from "./searchInProduct";

export const searchInOrder =
  (
    originalText = "",
    orderStatusText = defaultOrderStatusText,
    deliveryTypeText = defaultDeliveryTypeText,
  ) =>
  (order: TOrder): boolean => {
    const text = originalText.toLowerCase();
    return (
      String(order.id).toLowerCase().includes(text) ||
      String(order.createdAt).toLowerCase().includes(text) ||
      String(order.price).includes(text) ||
      String(order.trackOrderLink?.text).toLowerCase().includes(text) ||
      String(order.trackOrderLink?.href).toLowerCase().includes(text) ||
      (order.status !== undefined &&
        orderStatusText[order.status].toLowerCase().includes(text)) ||
      (order.delivery.type !== undefined &&
        deliveryTypeText[order.delivery.type].toLowerCase().includes(text)) ||
      !!order.products.find(searchInProduct(text))
    );
  };
